'use strict';

module.exports = {
    FILE: 'file',
    DIRECTORY: 'directory'
};